module.exports = __webpack_public_path__ + "img/Certificate_14.531111bc.jpg";